/**
 * Potree module entry point.
 *
 * This re-exports everything from Potree.js and exposes it as window.Potree
 * for backward compatibility with client code that accesses Potree via globals.
 */

import * as Potree from './Potree';
import './viewer/potree.css';

// Expose as global for backward compatibility
(window as unknown as { Potree: typeof Potree }).Potree = Potree;

export default Potree;
